import { createFileRoute } from '@tanstack/react-router';
import { MailboxView } from '~/components/mailbox-view';

export const Route = createFileRoute('/_authenticated/mailbox')({
    component: MailboxPage,
});

function MailboxPage() {
    return <MailboxView />;
}
